import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `
   <div>
     <ol>
        <li>Review driver and their DSP that have marked packages as cubeout. This is listed in the exception details.</li>
        <li>Open Cortex, and identify the remaining pickups on their route that will need coverage.</li>
        <li>Work with the current DSPs of the drivers to coordinate a rescue.</li>
        <ol>
            <li>If a rescue is successfully coordinated, submit a SIM to CO to reassign the packages to the new drivers - <a href="https://sim.amazon.com/issues/create?template=b80d75e7-e263-4a02-951f-a6d2d428b9ad">Reassignment SIM</a></li>
        </ol>
        <li>In the case a rescue with the current DSP is not possible, identify an alternate DSP who can cover the remaining pickups.</li>
        <ol>
            <li>Request Paid Rescue - This will allow you to assign an alternate DSP to the pickups - <a href="https://river.amazon.com/?org=CO_NA&buildingId=AUS11&q0=d83bfa8e-4bce-44fc-981f-be27d7b0e72f&q1=317fb208-c2fb-4ae7-b400-bda69030f51c">Paid Rescue Request Link</a></li>
            <li>Submit a SIM to CO to reassign the packages to the new drivers - <a href="https://sim.amazon.com/issues/create?template=b80d75e7-e263-4a02-951f-a6d2d428b9ad">Reassignment SIM</a></li>
        </ol>
        <li>If you are unable to coordinate a rescue please submit this SIM to CO - <a href="https://issues.amazon.com/issues/create?template=b1a10602-304d-465a-ba2e-3054e3a2fdc7">Unable to Rescue SIM</a></li>
     </ol>
     <p>Note, this work items has a 60 minute expiration. CO will begin to escalate via chime starting at 15 minutes until the process is completed.</p>
  </div>
   `
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_CO_SWA_Cubeout.jsx